import { ErrorPage } from "@/shared/components";

export function ServerError() {
  return <ErrorPage title="#500:" subtitle="Something went wrong" />;
}
